<template>
  <div>
    <my-header></my-header>
    <div class="content-box founder-banner">
      <div class="content-detail">
        <div class="text-box">
          <p class="title">创始人——韩志江</p>
          <p class="desc">浙江大学医学院附属邵逸夫医院放射科，副主任医师，博士，硕士研究生导师</p>
          <p class="text">“打造集放射、超声、核医学、心电图、病理、内镜于一体的大影像学习平台，打造集医、教、研、赛、试、乐于一体的综合学习软件。”</p>
          <p class="text p">—— 未来展望</p>
        </div>
      </div>
    </div>
    <div class="content-box founder-message">
      <div class="content-detail">
        <div>
        <div class="tip">
          <h1>创始人社会任职</h1>
          <img src="/static/img/founder/message.png" alt="">
        </div>
        <div class="office">
          <div class="left">
            <h1>学会任职（现任）</h1>
            <ul>
              <li v-for="(item, index) in nowOffice" :key="index">
                <span class="dot"></span>
                {{item}}
            </li>
            </ul>
          </div>
          <div class="right">
            <h1>学会任职（曾任）</h1>
            <ul class="margin">
              <li v-for="(item, index) in everOffice" :key="index">
                <span class="dot"></span>
                {{item}}
              </li>
            </ul>
            <h1>网络曾任职</h1>
            <ul>
              <li v-for="(item, index) in netOffice" :key="index">
                <span class="dot"></span>
                {{item}}
              </li>
            </ul>
          </div>
        </div>
        <div class="tip">
          <h1>创始人所获荣誉</h1>
          <img src="/static/img/founder/message.png" alt="">
        </div>
        <div class="office honor">
          <div class="left">
            <ul>
              <li v-for="(item, index) in honor" :key="index">
                <span class="dot"></span>
                {{item}}
            </li>
            </ul>
          </div>
        </div>
        <div class="tip">
          <h1>创始人使命</h1>
          <img src="/static/img/founder/message.png" alt="">
        </div>
        <div class="talk-text">“打造影像学习瑰宝，惠及各层次医务工作者。”</div>
        </div>
        <div class="wlzw">
          <div class="tip">
            <h1>
              <span class="tip-wlzw"><img src="/static/img/founder/message-right.png" alt="">未来展望</span>
            </h1>
          </div>
          <div class="talk-text">“打造集放射、超声、核医学、心电图、病理、内镜于一体的大影像学习平台，打造集医、教、研、赛、试、乐于一体的综合学习软件。”</div>
        </div>
        <div>
          <div class="tip">
            <h1>创始人影响力</h1>
            <img src="/static/img/founder/message.png" alt="">
          </div>
          <div class="office csryxl">
            <ul>
              <li>作为一名甲状腺疾病领域的专家，韩志江老师在临床医学和科研方面做出了很多杰出的贡献。他在甲状腺超声检查和影像诊断方面具有丰富的经验和深入的研究，对甲状腺结节的评估、诊断和治疗方案制定有着独到的见解和方法。在我看来，韩志江老师是一名医术精湛、知识渊博、实践经验丰富的专家。他在甲状腺领域的临床工作和科研方面都有着卓越的表现，为改善甲状腺疾病患者的健康状况做出了杰出的贡献。同时，韩志江老师还积极参与甲状腺疾病的教育和培训工作，为培养更多的甲状腺领域专业人才做出了重要贡献。他的学术水平和医疗技术得到了广泛的认可和赞誉，是甲状腺领域的一位杰出代表。</li>
            </ul>
          </div>
        </div>
        <div>
          <div class="tip tip-yellow">
            <h1>创始人的故事</h1>
            <img src="/static/img/founder/message-yellow.png" alt="">
          </div>
          <div class="story">
            <div class="box yy">
              <h1>引言</h1>
              <p class="text">从影二十载，经历了未知和挑战，充满了变数和永恒，尽管不能与成名成家的大咖相提并论，但受到丁香园园友、中国医学影像联盟盟友、放射沙龙龙友和SPARK星友们的鼓励，想再唠叨一下自己的从影学习经历及感受，亦纪录近天命之年的所思所想。如果您看过2016版（“相沙”韩志江：和年轻的影像人说说心里话）的内容，此次权当更新2.0版本，或许笔者的一些细节，一些观点可能更接地气，可能让您受益终生，亦或许能够让您的茶余饭后碎片时间有了更好的归处。没有华丽辞藻，只是简单叙述下自己的从影经历和一点浅见，请勿见笑。</p>
            </div>
            <div class="box xs">
              <img class="img" src="/static/img/founder/xs.jpg" alt="">
              <div class="div-inline-block">
                <h1>“相沙”的由来</h1>
                <p class="text">“相”同湘，沙是沙子的意思，相沙同湘沙，即为湘江里的一粒沙！湖南是笔者的第二故乡，在那留下了深深的足迹，虽时隔多年，仍向往湘江里沙子那样安然。笔者2002 年毕业于湘雅医学院临床医疗专业，大学期间虽然成绩一般，但学习态度还是非常诚恳的，整个实习期间，只逃了一个学科，那就是放射科，笔者常和别人说，“我逃了一周的放射轮转，上天让我用一辈子来弥补”。毕业后来到杭州市第一人民医院放射科工作，初来乍到，语言不习惯，饮食不习惯，更要命的是业务一点不懂，原因您懂得！看着老师们对图片指点江山的时候，心里尤其敬佩，渴求自己尽快能够像他们一样。业务学习上，跟着实习生学拍片，晚上跟实习生讨论什么是颈椎骨质增生，某一天，周健副主任看到我在跟实习生一起学习，他说：“小伙子，你怎么可以跟他们学习呢？”言外之意，自我定位太低了，从那以后，笔者开始思索个人的放射生涯该如何开始。</p>
              </div>
            </div>
            <div class="box xs ct">
              <div class="div-inline-block">
                <h1>CT基础及读片思路的来源</h1>
                <p class="text">笔者第一本正规影像书是周康荣教授的胸部CT 诊断，当看到这本书时，如获至宝，因为他把病变的病理、发病机制及影像联系的非常密切，而这正是笔者所需要的，反复参读，不知道多少遍了。后期又听说周教授还有一本腹部CT 的书，向来喜欢消化系统的我，当然不能错过，找了很多地方才买到，同样的反复参读，可以这么说，笔者的CT 基础及读片思路均来源于该两本书！</p>
              </div>
              <img class="img" src="/static/img/founder/CT.jpg" alt="">
            </div>
            <div>
              <h1>个人经历</h1>
              <div class="personal-experience">
                <div class="left">
                  <div v-for="(value, index) in years" :key="index" class="year-item">
                    <span :class="active==index?'active':''" @click="changeYear(index)">{{value.label}}</span>
                    <div class="dot-div">
                      <i class="dot"></i>
                    </div>
                  </div>
                </div>
                <div class="right">
                  <div v-if="active==0">开始读在职研究生，西医综合花了笔者近6 个月时间，还好，考了78 分（100 分满），也算对得起我的努力！西医综合的再次学习，让我对放射有了新的认识，我开始知道如何从临床的基础上学影像，也知道如何从影像的基础上重新认识临床。从2010年开始，笔者开始了真正意义上的专业知识的深入学习，一切都从甲状腺CT 开始，一直到今天，从开始的甲状腺大结节（大于3cm）都不会看，到现在微小结节的诊断（0.3-1.0cm），准确率虽然不如超声，但是70-80%总会有的，并且自学了超声，可以自豪的说：“在放射科，我是超声学的最好的，在超声科，我是放射学的最好的”，深深体会到了1+1＞＞2！通过超声的自学，我不但懂得了超声的优势，更重要的是知道其不足，如粗钙化和孤立性粗钙化，仅仅这个方面，笔者在国内外的发表的文章达15 篇，虽然档次并非很高，但至少得到了很多专家和杂志社的认可。</div>
                  <div v-if="active==1">2011 年上海瑞金医院进修半年，这对笔者的学术来说是巨大飞跃，瑞金的博大与严谨时刻影响着笔者，尤其得到了几位德高望重影像前辈们不倦教导，如严福华、汪登斌（现工作于上海新华医院放射科）和张华教授等，从而让笔者对肾脏、肾上腺、胰腺、腹膜后病变等系列产生了浓厚的兴趣！<br/>“相沙老师，给推荐几本书吧”，这是我经常碰到的问题。笔者觉得，作为初级医生，只要将课本熟读，深入的理解，然后再适当的辅以影像方面的专业书即可，如周康荣教授的胸部和腹部CT 等，最重要的精力要放在病理、解剖、组织胚胎学上，试想如果您能够对某种器官及其疾病的病理、解剖、组织胚胎学了如指掌，相信您闭上眼睛就能构思出其影像表现了，这样您的记忆更深，甚至终生难忘。以肾上腺为例，笔者在瑞金进修期间开始研究肾上腺，当初只知道肾上腺嗜铬细胞瘤和肾上腺皮质癌，经过反复学习，除了影像与病理对照外，还有熟练掌握其病理、解剖和组织胚胎学，两个月后，不但知道肾上腺各种病变的影像学表现，对其机制也是熟烂于心，对肾上腺各种病变的影像学特征都能够说出属于自己的一点东西，这可能就是原创吧。所以，笔者非常推崇的学习方法是“以点代面，各个突破”，即短时间内对某一小的领域进行深入学习，包括一切与之有关的医学知识，掌握一个点后，再拓展到另外一个点，慢慢的，您会发现原来很小的多个点，已经变成了一个可观的面了。</div>
                  <div v-if="active==2">从2014 年至2020年，笔者历经了丁香园、中国医学影像论坛微信群、放射沙龙APP和放射沙龙公益联盟的管理工作，其中认识了一大批知识渊博的专家，有的甚至同时出现在这四个板块中，他们的共同特点就是对知识的执着，甚至用痴迷来形容更为恰当，也正是因为这样，他们才能够在各自的版块中独领风骚！丁香园在医学界是绝对的权威，估计没有任何人会产生怀疑，其最大特色是功能齐全，对群友们提供的图片要求也很高，所以，非常适合您去总结归纳，我常和别人说，“如果您自学能力强，与其去三甲医院进修，不如在丁香园里闭关学习”。中国医学影像论坛微信群建群20个月，还记得建群第一天的喜悦，其以高活跃度和高读片质量而闻名，不同群有各自特色，仅以颈部群入群标准来说，作为全国唯一的颈部影像群，全国颈部大腕多汇聚于此，对入群者自身颈部业务能力的要求自然高些，很多老师因为能够入颈部群而兴奋不已，这和那些到处拉人入群的论坛形成鲜明对比。放射沙龙APP是放射沙龙公司呕心沥血打造的品牌，目标很明确：打造全国最权威的影像APP，在这里，您可以获得您所需要的一切，安装使用的客户达数万人，粉丝数十万，有中华医学会很多大腕加盟，提供了非常多优秀的课件和视频，让您足不出户而能够领略大家风采，并且，推出的专家在线会诊功能会秒杀所以类似的影像APP；放射沙龙公益联盟成立于2016年10月16号，三个月内建立300+群，覆盖4.5万人群，还有很多其他的影像联盟，这里不一一例出。</div>
                  <div v-if="active==2" class="margin">2019年伊始，受科室主任丁忠祥教授委托，主管科室教学工作。经过3年的观察与思考，深刻体会到大家对各种网络学习平台热度锐减，越来越适合更小一部分学习积极性高、学习能力强的影像专业或与之密切相关专业的医务人员，如呼吸科、胸外科、骨科、五官科等，并非适合我们所有的住培学员及在校大学生。显然，如果能提升包括医学生在内所有医务人员的影像学水平，达到医学生危急值影像学素质化教育、临床住培学员专科化影像学素质化教育、临床医师影像学专科化教育、影像医师影像学系统化教育，将会是利国利民的一件大事。2020年伊始，在丁忠祥主任的鼎力支持下，我开始有了研发星火影像教学平台（SPARK）的想法，但如何开发？开发呈啥样？缺少实战教学经验的我，完全一头雾水。在开发工程师的建议下，我们兵分两路，一路边开发、边思考，另一路招募了省内外30余家医院加入出题的队伍，此期间艰辛与曲折可想而知------。终于，于2020年9月，SPARK 1.0版终于问世，巨大的题量让大家耳目一新，但显然，产品过于粗糙，功能过于简单，仍然不适合专业教学，需要进一步更新迭代。但可想而知，实践出真知，我们开始系统的将SPARK运用于教学工作中，并且不断发现其不足，并予以更新、完善------。为了全身心投入到SPARK的开发与建设中，2021年12月30日，笔者辞去了放射沙龙公益联盟、中国医学影像联盟总盟主的头衔，退出了所有的群（400余），尽管万般不舍，但也是百般无奈，自己能力有限、精力实在不足。</div>
                  <div v-if="active==3">2022年3月，笔者偶然间获得灵感，我们是否可以开发集放射（诊断+技术）、超声、核医学、病理、心电图、内镜六位一体的综合影像平台呢？毕竟这些影像学学习方法都是大同小异，尤其是放射、超声和核医学，如何能够达到学科间知识的融合，那对于疾病影像的理解将会有非常大的作用。但随着而来的困难也可想而知：超声、核医学、病理、心电图和内镜板块的领路人怎么找呢？尽管笔者是放射方面的“网红”，但在其他领域，完全是小白一枚。但功夫不负有心人，经过几个月的苦苦寻找，终于完成了大家庭的组建。截止目前为止，放射核心单位包括诊断40家和技术20余家，超声近30余家，核医学近10家，心电图近10家，病理和内镜尚未正式建设，后续随着平台建设的需求，会定期更新核心单位，不断提升核心单位级别。</div>
                </div>
              </div>
              <div class="end-txt">对于教学而言，笔者高度重视课题立项和文章发表。在课题方面，积极鼓励核心单位申请教改课题，目前已经获得29项课题立项，包括2项浙江省教育厅十四五规划项目，1项教育厅一般项目，还有近10项科技局项目，余大部分为高校课题。在论文书写方面，目前已经在国际知名医学教育期刊BMC medical education发表论文一篇，在国内医学教育天花板期刊中华医学教育杂志发表论文一篇，另外，还在其他医学杂志发表文章4篇，获得专家一致好评。</div>
              <p class="end-title">医影之路漫漫，一个人走太寂寞，相沙邀请您同行！</p>
              <div class="card">
                <img src="/static/img/founder/card.png" alt="">
                <p class="">创始人微信</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <my-footer></my-footer>
  </div>
</template>
<script>
import myFooter from './myFooter.vue'
import myHeader from './myHeader.vue'
export default {
  name: 'founder',
  components: {
    myHeader: myHeader,
    myFooter: myFooter
  },
  data () {
    return {
      nowOffice: [
        '中华医学会放射学分会第十七届委员会头颈学组委员；',
        '中华医学会放射学分会第十七届医学影像教育工作组；',
        '中华医学会放射学分会第十七届海峡两岸学术交流工作组成员；',
        '中国抗癌协会甲状腺癌专业委员会委员；',
        '中国医疗保健国际交流促进会甲状腺疾病分会委员；',
        '中国研究型医院学会甲状腺疾病专业委员会委员；',
        '中国医学装备协会磁共振专业委员会委员；',
        '中国医学影像整合联盟头颈部专业委员会委员；',
        '中国中西医学会普通外科专委会甲状腺与甲状旁腺专家委员会；',
        '中国生物医学工程学会医学影像工程与技术分会青年委员；',
        '浙江省数理医学会甲状腺疾病专业委员会副主任委员；',
        '浙江省医学会放射学分会神经学组委员；',
        '浙江省抗癌协会甲状腺癌专业委员会委员；',
        '浙江省数理医学会放射专业委员会委员；',
        '浙江省医师协会甲状腺疾病专业委员会委员；',
        '浙江省医学会放射学分会头颈学组副组长；',
        '浙江医师协会放射医师分会教育学组副组长。',
      ],
      everOffice: [
        '中华医学会放射学分会第十六届委员会头颈学组Youth Club成员；',
        '中国医师协会头颈部专业委员会委员；',
        '中华医学会放射学分会法律与维权专业委员会委员；',
        '第14届中华医学会头颈部学组青年委员；',
        '浙江省抗癌协会甲状腺肿瘤青年学组副主任委员；',
        '中华放射学杂志、中华内分泌外科杂志、浙江中西医结合杂志、影像诊断与介入放射学杂志审稿专家，中国临床医学影像杂志和国际医学放射学杂志青年/通讯编委；',
        '杭州市医学会核医学专业委员会副主任委员；',
        '杭州市医学会甲状腺癌专业委员会委员等。'
      ],
      netOffice: [
        '丁香园医学论坛影像医学与核医学版块版主（相沙，粉丝近24万）；',
        '2013年获得最佳园友的荣誉，2014-2015年获得最佳版主的荣誉；',
        '放射沙龙公益联盟总盟主（近4万人）；',
        '《中国医学影像联盟》总盟主（5万人+）。'
      ],
      honor: [
        '2023年艾力彼创新医疗科技案例大赛二等奖；',
        '星火影像住培（SPARK影像学习平台）创始人；',
        '2022艾力彼创新科技赋能医管案例大赛一等奖；',
        '2021年浙江省科学技术进步二等奖排位2；',
        '2021年浙江省优秀教学主任；',
        '2018年获得第八届全国甲状腺肿瘤学术大会青年论坛临床研究大赛二等奖；',
        '2017年获得《中华医学会放射学分会2017年全国头颈部学大会中文论文比赛二等奖》；',
        '2016年获得刘玉清院士优秀论文奖；',
        '浙江大学医学院第六届高校教师教学创新大赛一等奖；',
        '以第一或通讯作者身份发表文章150余篇；',
        '主编及副主编专业书籍11本；',
        '星火影像住培软件（SPARK）发起人。',
      ],
      years: [
        {label: '2005~2009'},
        {label: '2011'},
        {label: '2014~2020'},
        {label: '2022'}
      ],
      active: 0
    }
  },
  methods: {
    changeYear (index) {
      this.active = index
    }
  }
}
</script>
<style rel="stylesheet/less" lang="less" scoped>
.founder-banner {
  background: url("/static/img/founder/banner.jpg") no-repeat;
  height: 560px;
  background-repeat: no-repeat;
  background-size: cover;
  .content-detail {
    color: #fff;
    position: relative;
    .text-box{
      text-align: left;
      width: 642px;
      position: absolute;
      right: 0;
      top: 102px;
      .title{
        font-family: SourceHanSansSC-Medium;
        font-size: 30px;
        line-height: 30px;
        font-weight: 500;
      }
      .desc{
        font-family: SourceHanSansSC-Regular;
        font-size: 14px;
        color: #FFFFFF;
        font-weight: 400;
        margin-top: 16px;
      }
      .text{
        font-family: LiDeBiao-Xing;
        font-size: 24px;
        line-height: 48px;
        font-weight: 400;
        margin-top: 32px;
      }
      .text.p{
        text-align: right;
        margin-top: 8px;
      }
    }
  }
}
.founder-message{
  background: #F9FBFF;
  padding-top: 18px;
  .content-detail{
    text-align: left;
  }
  .tip{
    background: #0056F8;
    color: #fff;
    border-radius: 8px;
    padding: 6px 16px;
    display: inline-block;
    position: relative;
    margin: 24px 0 16px 0;
    img{
      width: 22px;
      height: 20px;
      position: absolute;
      right: -10px;
      bottom: -2px;
    }
  }
  .tip-yellow{
    background: #D48200;
  }
  .office{
    display: flex;
    text-align: left;
    background: #fff;
    color: #50555F;
    box-shadow: 0px 0px 12px 0px rgba(0,86,248,0.1);
    border-radius: 16px;
    padding: 16px 24px;
    .left, .right{
      width: 50%;
    }
    h1{
      font-family: SourceHanSansSC-Bold;
      font-size: 16px;
      color: #000000;
      line-height: 24px;
      font-weight: 700;
      margin-bottom: 16px;
    }
    ul{
     li {
      font-family: SourceHanSansSC-Regular;
      font-size: 14px;
      color: #50555F;
      line-height: 28px;
      font-weight: 400;
      .dot{
        display: inline-block;
        width: 4px;
        height: 4px;
        background: #50555F;
        border-radius: 50%;
        vertical-align: middle;
        margin-top: -2px;
        margin-right: 3px;
      }
     }
    }
    .margin{
      margin-bottom: 24px;
    }
  }
  .honor{
    width: 601px;
    .left{
      width: 100%;
    }
  }
  .talk-text{
    font-family: DingTalk-JinBuTi;
    font-size: 24px;
    color: #0056F8;
    text-align: center;
    line-height: 48px;
    font-weight: 400;
    padding: 10px 24px;
    background: #fff;
    box-shadow: 0px 0px 12px 0px rgba(0,86,248,0.1);
    border-radius: 16px;
    width: 576px;
  }
  .wlzw{
    text-align: right;
    position: relative;
    .tip{
      display: block;
      background: transparent;
      padding: 0;
      .tip-wlzw{
        background: #0056F8;
        color: #fff;
        border-radius: 8px;
        padding: 6px 16px;
        display: inline-block;
        position: relative;
        margin: 24px 0 16px 0;
        img{
          position: absolute;
          left: -10px;
        }
      }
    }
    .talk-text{
      display: inline-block;
      width: 888px;
      text-align: right;
    }
  }
  .csryxl{
    padding: 10px 24px;
  }
  .story{
    margin-bottom: 100px;
    padding: 0 24px 20px 24px;
    padding-top: 20px;
    background: url("/static/img/founder/story-bg.png") no-repeat;
    background-size: 100% 100%;
    border-radius: 15px;
    box-shadow: 0px 0px 12px 0px rgba(0, 86, 248, 0.1);
    .box{
      margin: 0 0 26px 0;
    }
    .text{
      font-size: 14px;
      color: #734100;
      line-height: 28px;
      font-weight: 400;
    }
    h1{
      font-family: MicrosoftYaHei-Bold;
      font-size: 20px;
      color: #D48200;
      font-weight: 700;
    }
    .yy{
      h1{
        text-align: center;
        line-height: 28px;
        font-weight: 700;
        margin-bottom: 16px;
      }
    }
    .xs{
      .img{
        width: 535px;
        height: 332px;
        vertical-align: top;
      }
      .div-inline-block{
        width: 551px;
        display: inline-block;
        margin-left: 16px;
        h1{
          margin-bottom: 24px;
        }
      }
    }
    .ct{
      .img{
        width: 535px;
        height: 248px;
      }
      .div-inline-block{
        margin-left: 0;
        margin-right: 16px;
      }
    }
    .personal-experience::after{
      content: "";
      display: block;
      height: 0;
      clear:both;
      visibility: hidden;
    }
    .personal-experience{
      margin-top: 24px;
      .left, .right {
        display: inline-block;
      }
      .left{
        float: left;
        width: 230px;
        .year-item{
          margin-bottom: 20px;
          position: relative;
          width: 230px;
          height:32px;
        }
        .dot-div{
          width: 22px;
          height: 22px;
          padding: 4px;
          border-radius: 50%;
          border: 1px solid transparent;
          transition: all .2s;
          position: absolute;
          left: 0;
          top: 5px;
        }
        .dot{
          display: inline-block;
          width: 12px;
          height: 12px;
          border-radius: 50%;
          background: #B8BCC3;
        }
        span{
          font-family: MicrosoftYaHei-Bold;
          display: inline-block;
          font-size: 20px;
          color: #734100;
          line-height: 28px;
          font-weight: 700;
          cursor: pointer;
          position: absolute;
          left: 32px;
        }
        span:after{
          display: block;
          content: '';
          width: 0px;
          height: 4px;
          background: transparent;
          border-radius: 4.5px;
        }
        span.active{
          font-size: 20px;
          color: #F89800;
          line-height: 28px;
          font-weight: 700;
        }
        span.active:after{
          width: 120px;
          background: #F89800;
          transition: all .5s;
        }
        span.active + .dot-div{
          border: 1px solid rgba(248,152,0,1);
          padding: 4px;
          .dot{
            background: #F89800;
          }
        }
      }
      .right{
        float: right;
        width: 922px;
        padding: 16px;
        background: #FFF1DF;
        box-shadow: 0px 0px 10px 0px rgba(209,113,0,0.5);
        border-radius: 8px;
        font-family: SourceHanSansSC-Regular;
        font-size: 14px;
        color: #734100;
        line-height: 28px;
        font-weight: 400;
        div{
          text-indent: 2rem;
        }
        .margin{
          margin-top: 16px;
        }
      }
    }
    .end-txt{
      font-family: SourceHanSansSC-Regular;
      font-size: 14px;
      color: #734100;
      line-height: 28px;
      font-weight: 400;
      margin-top: 32px;
    }
    .end-title{
      font-family: DingTalk-JinBuTi;
      font-size: 24px;
      color: #D48200;
      text-align: center;
      line-height: 48px;
      font-weight: 400;
      margin-top: 16px;
    }
    .card{
      text-align: center;
      margin-top: 20px;
      img {
        width: 120px;
        height: 120px;
      }
      p{
        margin-top: 20px;
        font-family: SourceHanSansSC-Regular;
        font-size: 14px;
        color: #D48200;
        font-weight: 400;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/founder.vue